<img src="{{this.src}}?{{now}}" (click)="onImageClick()"/>

<div class="modalbg" *ngIf="isOpened" (click)="onDivClick()" [ngStyle]="{display: isOpened ? 'grid': 'none'}">
  <img src="{{this.src}}?{{now}}" />
</div>
